const ProductLookupFixture = [
    {
        field: "item_id",
        title: "ITEM_ID",
        filter: false,
        border: true,
        show: true,
        min_width: 20,
    },
    {
        field: "title",
        title: "TITLE",
        border: true,
        filter: false,
        show: true,
        min_width: 20,
    },
    {
        field: "barcodeValue",
        title: "BARCODE_VALUE",
        border: true,
        filter: false,
        show: true,
        min_width: 20,
    },

    {
        field: "brand",
        title: "Brand BRAND",
        border: true,
        filter: false,
        show: true,
        min_width: 20,
    },
    {
        field: "manufacturer",
        title: "MANUFACTURER",
        border: true,
        filter: false,
        show: true,
        min_width: 20,
    },
]
export default ProductLookupFixture